// extracted by mini-css-extract-plugin
export var logoWrapper = "jp_FG";